import { GetCookieBannerTextProps, GetCookieBannerTextReturn } from './interfaces';

export const videosEnabledId = 'videos';
export const getCookieBannerText = ({
  language,
  facebookPixelEnabled,
  facebookConversionsApiEnabled,
  googleTagManagerEnabled,
  handleCheckedToggles,
  videosEnabled,
  tiktokPixelEnabled,
  linkedInEventsEnabled,
  provenEmployerEnabled,
}: GetCookieBannerTextProps): GetCookieBannerTextReturn => {
  let legalInformationText: string = '"Rechtliche Informationen"';
  let acceptButtonText: string = 'Alle Datenschutzoptionen akzeptieren';
  let cookieMessageText1: string = `Wir verwenden Cookies und ähnliche Technologien (z. B. Local Storage), um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien bereitzustellen und Zugriffe auf unsere Website zu analysieren.
Zusätzlich geben wir Informationen zu deiner Nutzung unserer Website an Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner können diese mit weiteren Daten zusammenführen, die du ihnen bereitgestellt hast oder die sie im Rahmen deiner Nutzung gesammelt haben.
Am Ende jeder Seite kannst du alle Einstellungen über den Link "Datenschutzeinstellungen" ändern und Einwilligungen widerrufen. Weitere Informationen findest du unter `;
  let cookieMessageText2: string =
    'Unter "Datenschutzeinstellungen" kannst du anpassen, welche Cookies und lokalen Speichertechnologien verwendet werden bzw. Cookies und Local Storage ablehnen.';
  let openCookieSettingsText: string = 'Datenschutzeinstellungen';
  let rejectAllButtonText = 'Alle Datenschutzoptionen ablehnen';

  let consentManager: any = {
    headline: 'Datenschutzeinstellungen',
    explanation: `
    <b>Erklärung von Cookies und ähnlichen Technologien</b>
    <p>Cookies und ähnliche Technologien wie Local Storage sind zentrale Bestandteile moderner Browser-Technologien. Sie ermöglichen es, dass Websites eine bessere Interneterfahrung bieten können. Wenn du beispielsweise eine Bewerbung versendest oder Eingaben tätigst, kann unsere Website dich beim nächsten Mal wiedererkennen und du musst deine Daten nicht erneut eingeben.</p>

    <b>Cookie- und Local Storage-Nutzung</b>
    <p>Wir nutzen Cookies und Local Storage ausschließlich, um die Funktionsweise unserer Website zu verbessern und unsere Kampagnen zu optimieren. Dazu gehört auch, Eingaben oder Fortschritte auf der Website zwischenzuspeichern. Soweit technisch erforderlich, erfolgt die Speicherung auf Grundlage unseres berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO. Du kannst diese Speicherungen dennoch blockieren. Wenn unten die Einstellungen für die Verarbeitung von Facebook, Google, LinkedIn, TikTok oder Video aufgeführt sind und du diesen zustimmst, werden deine Daten auch außerhalb der EU verarbeitet (Art. 49 DSGVO).</p>

    <b>Anpassung</b>
    <p>Du kannst einzelne oder alle Cookies, Tracking-Mechanismen und lokalen Speicherungen blockieren. Dies kann jedoch dazu führen, dass bestimmte Funktionen, wie etwa die Speicherung deiner Eingaben, nicht mehr nutzbar sind.
Auf vielen Websites müssen Cookies oder Local Storage aktiviert sein, damit du dich anmelden oder Fortschritte speichern kannst. Uns helfen sie auch dabei, die Website zu optimieren und dir einen besseren Service bieten zu können.</p>
    
    <p>Am Ende der Seite kannst du deine Datenschutzeinstellungen bearbeiten. Weitere Informationen zum Anpassen deiner Datenschutzeinstellungen findest du auch in der Hilfefunktion deines Browsers.</p>
    
    <b>Diese Meldung nicht mehr anzeigen</b>
    <p>Wenn du Cookies oder lokale Speicherungen regelmäßig löschst, wird dieser Hinweis weiterhin eingeblendet, da wir nicht erkennen können, ob du bereits zugestimmt hast.</p>`,

    acceptAll: 'Alle Datenschutzoptionen akzeptieren',
    acceptSelection: 'Einstellungen übernehmen',
    toggles: [
      {
        id: 'meetovo-tracking',
        title: 'Eingabe-Tracking bearbeiten',
        explanation:
          'Sichert die Eingaben, die auf dieser Website eingegeben werden. Wir analysieren damit das Eingabeverhalten unserer Besucher.',
        callback: handleCheckedToggles,
      },
    ],
  };

  let confirmPopup = {
    text: `Durch deine derzeitigen Einstellungen können wir und die Plattformen, mit denen wir
    arbeiten, keine personalisierten Inhalte für dich anzeigen bzw. die Website
    analysieren. Es kann außerdem zu Einschränkungen bei der Benutzung kommen. Willst du
    deine Datenschutzeinstellungen trotzdem speichern?`,
    acceptSelection: 'Einstellungen übernehmen',
    acceptAll: 'Alle Datenschutzoptionen akzeptieren',
  };

  if (language === 'EN') {
    confirmPopup = {
      text: `Your current settings prevent us and the platforms we work with from displaying personalized content for you or analyzing the website. You may also experience some limitations in your use of the site. Do you still want to save your data privacy settings?`,
      acceptSelection: 'Apply settings',
      acceptAll: 'Accept all data privacy options',
    };

    legalInformationText = 'Legal information';
    acceptButtonText = 'Accept all data privacy options';
    cookieMessageText1 =
      'We use cookies and similar technologies (e.g. local storage) to personalize content and ads, provide social media features, and analyze access to our website. Additionally, we share information about your use of our website with our partners for social media, advertising, and analytics. Our partners may combine this with other data that you have provided to them or that they have collected as part of your usage. At the bottom of each page, you can change all settings via the "Open data privacy settings" link and revoke consents. You can find more information under ';
    cookieMessageText2 =
      'Under "Open data privacy settings" you can customize which cookies and local storage technologies are used or reject cookies and local storage.';
    openCookieSettingsText = 'Open data privacy settings';
    rejectAllButtonText = 'Reject all data privacy options';

    consentManager = {
      headline: 'Information for cookies',
      explanation: `<b>Information about cookies and similar technologies</b>
        <p>Cookies and similar technologies such as local storage are central components of modern browser technologies. They make it possible for websites to offer a better internet experience. For example, if you send an application or make entries, our website can recognize you the next time you visit and you do not have to enter your data again.</p>
    
        <b>Cookie and local storage usage</b>
        <p>We use cookies and local storage exclusively to improve the functionality of our website and optimize our campaigns. This includes temporarily storing inputs or progress on the website. Where technically necessary, storage is based on our legitimate interest pursuant to Art. 6 para. 1 lit. f GDPR. You can still block these storage methods. If the settings for Facebook, Google, LinkedIn, TikTok or Video processing are listed below and you agree to them, your data will also be processed outside the EU (Art. 49 GDPR).</p>
        
        <b>Customization</b>
        <p>You can block individual or all cookies, tracking mechanisms, and local storage. However, this may mean that certain functions, such as saving your inputs, are no longer usable.
Many websites require cookies or local storage to be enabled for you to log in or save progress. They also help us optimize the website and provide you with better service.</p>
        
        <p>You can edit your data privacy settings at the bottom of the page. You can also find more information about customizing your data privacy settings in your browser's help feature.</p>
        
        <b>Do not show this message again</b>
        <p>If you regularly delete cookies or local storage, this notice will continue to be displayed, as we cannot detect whether you have already consented.</p>`,
      acceptAll: 'Accept all data privacy options',
      acceptSelection: 'Apply settings',
      toggles: [
        {
          id: 'meetovo-tracking',
          title: 'Edit input tracking',
          explanation:
            'Records all information entered on this website. We use it to analyse the input behaviour of our visitors.',
          callback: handleCheckedToggles,
        },
      ],
    };
  }

  if (facebookConversionsApiEnabled && language !== 'EN')
    consentManager.toggles.unshift({
      id: 'facebook-conversion-api',
      title: 'Facebook Conversions API bearbeiten',
      explanation:
        'Die Facebook Conversions API zeichnet über den Server auf, welche Seiten besucht wurden. Wir nutzen diese, um unsere Facebook-Kampagnen zu optimieren.',
      callback: handleCheckedToggles,
    });

  if (facebookConversionsApiEnabled && language === 'EN')
    consentManager.toggles.unshift({
      id: 'facebook-conversion-api',
      title: 'Edit Facebook Conversions API',
      explanation:
        'The Facebook Conversions API records via the server which pages were visited. We use this to optimize our Facebook campaigns.',
      callback: handleCheckedToggles,
    });

  if (facebookPixelEnabled && language !== 'EN')
    consentManager.toggles.unshift({
      id: 'facebook-pixel',
      title: 'Facebook-Pixel bearbeiten',
      explanation:
        'Facebook-Pixel zeichnen auf welche Seiten besucht wurden. Wir nutzen Facebook-Pixel, um unsere Facebook-Kampagnen zu optimieren.',
      callback: handleCheckedToggles,
    });

  if (facebookPixelEnabled && language === 'EN')
    consentManager.toggles.unshift({
      id: 'facebook-pixel',
      title: 'Edit Facebook-Pixel',
      explanation:
        'Facebook-Pixel records which pages have been visited. We use Facebook-Pixel to optimize our Facebook campaigns.',
      callback: handleCheckedToggles,
    });

  if (tiktokPixelEnabled && language === 'EN')
    consentManager.toggles.unshift({
      id: 'tiktok-pixel',
      title: 'Edit TikTok-Pixel',
      explanation:
        'TikTok-Pixel records which pages have been visited. We use TikTok-Pixel to optimize our TikTok campaigns.',
      callback: handleCheckedToggles,
    });

  if (tiktokPixelEnabled && language !== 'EN')
    consentManager.toggles.unshift({
      id: 'tiktok-pixel',
      title: 'TikTok-Pixel bearbeiten',
      explanation:
        'TikTok-Pixel zeichnet auf, welche Seiten besucht wurden. Wir verwenden TikTok-Pixel, um unsere TikTok-Kampagnen zu optimieren.',
      callback: handleCheckedToggles,
    });

  if (linkedInEventsEnabled && language === 'EN')
    consentManager.toggles.unshift({
      id: 'linkedin-event',
      title: 'Edit Linkedin Insight-Tag',
      explanation:
        'Linkedin Insight-Tag records which pages have been visited. We use LinkedIn Insight-Tag to optimize our LinkedIn campaigns.',
      callback: handleCheckedToggles,
    });
  if (provenEmployerEnabled && language !== 'EN')
    consentManager.toggles.unshift({
      id: 'proven-employer',
      title: 'ProvenEmployer-Siegel bearbeiten',
      explanation:
        'Zur Anzeige authentischer Mitarbeiterbewertungen binden wir das ProvenEmployer-Siegel ein. Dabei werden Daten wie IP-Adressen an die Bewertungsplattform übermittelt.',
      callback: handleCheckedToggles,
    });
  if (provenEmployerEnabled && language === 'EN')
    consentManager.toggles.unshift({
      id: 'proven-employer',
      title: 'Edit Proven Employer Seal',
      explanation:
        'To display authentic employee reviews, we integrate the ProvenEmployer seal. Data such as IP addresses are transmitted to the evaluation platform.',
      callback: handleCheckedToggles,
    });

  if (linkedInEventsEnabled && language !== 'EN')
    consentManager.toggles.unshift({
      id: 'linkedin-event',
      title: 'Linkedin Insight-Tag bearbeiten',
      explanation:
        'Linkedin Insight-Tag zeichnet auf, welche Seiten besucht wurden. Wir verwenden LinkedIn Insight-Tag, um unsere LinkedIn-Kampagnen zu optimieren.',
      callback: handleCheckedToggles,
    });

  if (googleTagManagerEnabled && language !== 'EN')
    consentManager.toggles.unshift({
      id: 'google-tag-manager',
      title: 'Google Tag Manager bearbeiten',
      explanation:
        'Der Google Tag Manager zeichnet auf welche Seiten besucht wurden. Wir nutzen Google Tag Manager, um unsere Google-Kampagnen zu optimieren.',
      callback: handleCheckedToggles,
    });

  if (googleTagManagerEnabled && language === 'EN')
    consentManager.toggles.unshift({
      id: 'google-tag-manager',
      title: 'Edit Google Tag Manager',
      explanation:
        'The Google Tag Manager records which pages have been visited. We use Google Tag Manager to optimize our Google campaigns.',
      callback: handleCheckedToggles,
    });

  if (videosEnabled && language !== 'EN')
    consentManager.toggles.unshift({
      id: videosEnabledId,
      title: 'Video bearbeiten',
      explanation:
        'Wir nutzen Videos um die Inhalte auf dieser Seite ansprechend zu vermitteln. Beim Anschauen von Videos können Analysedaten z.B. über die Abspieldauer an Drittanbieter übertragen werden.',
      callback: handleCheckedToggles,
    });

  if (videosEnabled && language === 'EN')
    consentManager.toggles.unshift({
      id: videosEnabledId,
      title: 'Edit video',
      explanation:
        'We use videos to show the content on this page in an appealing way. When watching videos, analytics data may be transmitted to third parties, e.g. about the playback time.',
      callback: handleCheckedToggles,
    });

  if (language !== 'EN')
    consentManager.toggles.unshift({
      id: 'google-fonts',
      title: 'Google Fonts bearbeiten',
      explanation:
        'Google Fonts ist eine Sammlung von Schriftarten, die wir nutzen, um diese Seite in einem ansprechenden Design darzustellen.',
      callback: handleCheckedToggles,
    });

  if (language === 'EN')
    consentManager.toggles.unshift({
      id: 'google-fonts',
      title: 'Edit Google Fonts',
      explanation:
        'Google Fonts is a collection of fonts that we use to present this site in a beautiful design.',
      callback: handleCheckedToggles,
    });

  return {
    banner: {
      legalInformationText,
      acceptButtonText,
      cookieMessageText1,
      cookieMessageText2,
      openCookieSettingsText,
      rejectAllButtonText,
    },
    consentManager,
    confirmPopup,
  };
};
